import { render, staticRenderFns } from "./BagSizes.vue?vue&type=template&id=0caefa3d"
import script from "./BagSizes.vue?vue&type=script&lang=js"
export * from "./BagSizes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports